import styled from "styled-components";
import { DesignTokens } from "melco-ui";

const { spacings, colors } = DesignTokens;

// WHAT: the three-column layout row that holds the user/machine/logs panels.
// WHY: `overflow: hidden` on the row (rather than the page) is what lets each
// child Panel scroll independently instead of the whole workspace scrolling.
export const WorkspaceRow = styled.div`
  display: flex;
  flex: 1;
  overflow: hidden;
`;

// WHAT: one column of the three-column workspace.
// WHY a `width` prop instead of always using flex: the first two columns
// (user search, machines) are fixed-width by design so the logs panel gets
// whatever space is left. Passing no width falls back to `flex: 1` for that
// last, growable column.
export const Panel = styled.div<{ width?: number }>`
  ${({ width }) => (width ? `width: ${width}px; flex-shrink: 0;` : "flex: 1; min-width: 0;")}
  border-right: 1px solid ${colors.gray.light};
  display: flex;
  flex-direction: column;
  overflow: hidden;
  background: white;
`;

// "STEP N — ..." eyebrow label used above each panel's content.
export const StepLabel = styled.div`
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.1em;
  text-transform: uppercase;
  color: ${colors.gray.middle};
  margin-bottom: 9px;
`;

export const PanelHeading = styled.div`
  padding: 0px ${spacings.middle}px;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.1em;
  text-transform: uppercase;
  color: ${colors.gray.middle};
  border-bottom: 1px solid ${colors.gray.light};
  flex-shrink: 0;
`;

// Generic "nothing to show yet" placeholder, reused for every empty/prompt
// state across all three panels (select a user, select an add-on, select a
// machine, no machines found, etc.) so those states look consistent.
export const CenteredMessage = styled.div`
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: ${spacings.large}px ${spacings.middle}px;
  text-align: center;
  font-size: 13px;
  color: ${colors.gray.middle};
`;

export const Breadcrumb = styled.div`
  padding: 6px ${spacings.middle}px;
  border-bottom: 1px solid ${colors.gray.light};
  display: flex;
  align-items: center;
  gap: 6px;
  flex-shrink: 0;
  background: ${colors.gray.superLight};
  font-size: 12px;
`;

export const Crumb = styled.span<{ active?: boolean }>`
  padding: 2px 9px;
  border-radius: 10px;
  color: ${({ active }) => (active ? colors.main.negative : colors.gray.dark)};
  font-weight: ${({ active }) => (active ? 600 : 400)};
`;

export const TopBar = styled.div`
  display: flex;
  align-items: center;
  gap: ${spacings.small}px;
  flex-wrap: wrap;
  padding: 9px ${spacings.middle}px;
  border-bottom: 1px solid ${colors.gray.light};
  background: ${colors.gray.superLight};
  flex-shrink: 0;
`;

export const MachineLabel = styled.span`
  font-size: 14px;
  font-weight: 600;
  color: ${colors.gray.dark};
`;

export const ShowAllMachinesRow = styled.div`
  padding: ${spacings.small}px ${spacings.middle}px;
  border-bottom: 1px solid ${colors.gray.light};
  font-size: 12px;
  color: ${colors.gray.dark};
  flex-shrink: 0;
`;
